'use strict';

const {fillWithShapeOptions, sanitizeDegrees, noMoreThan} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('customize-polygons', function () {
    let autoOpacity;
    let hueOffset = 0;
    let hueRange = 360;
    let rotation = 0;

    let selectOptions = [];
    for (let i = 3; i <= 20; i++) selectOptions.push(i);
    for (let i = 10; i < 500; i += i) {
        selectOptions.push(i);
    }
    //selectOptions.push(30, 50, 80, 120);
    const select = this.addShapeSelector(selectOptions, 7);

    const [outlineControl] = this.addLabeledCheckbox('Outline', false);
    const [subOutlineControl] = this.addLabeledCheckbox('Outline Sub-Shapes', true);
    const [ratioDescription, ratioInput] = this.addLabeledSlider('Ratio: ', 1, 100, 50);
    const [rotationLabel, rotationInput] = this.addLabeledSlider('Rotation: ', 0, 360, rotation);
    const [hueRangeDescription, hueRangeInput] = this.addLabeledSlider('Hue Range: ', 0, 2160, 360);
    const [hueOffsetDescription, hueOffsetInput] = this.addLabeledSlider('Hue Offset: ', 0, 360, 0);
    const [saturationDescription, saturationInput] = this.addLabeledSlider('Saturation: ', 0, 100, 100);
    const [lightnessDescription, lightnessInput] = this.addLabeledSlider('Lightness: ', 0, 100, 50);
    const [autoRadio, manualRadio] = this.addRadioButtons('Opacity Mode: ', [{
        value: 'Auto', checked: true
    }, {
        value: 'Manual'
    }]);
    const opacityPrecision = 1;
    const [opacityDescription, opacitySlider] = this.addLabeledSlider('Opacity: ', 0, 100 * Math.pow(10, opacityPrecision), 50 * Math.pow(10, opacityPrecision));

    const controls = [select, ratioInput, lightnessInput,
        hueRangeInput, rotationInput, manualRadio, autoRadio,
        saturationInput, outlineControl, hueOffsetInput,
        subOutlineControl, opacitySlider];
    console.log(controls);
    this.queryAll('.opacity-radio').forEach(c => controls.push(c));

    const _updateDrawing = () => {
        const shape = new Shape(parseInt(select.value, 10), Point.origin(), 100);
        shape.scaleToFitWithin(this.width - (this.pad * 2), this.width - (this.pad * 2));
        shape.setAnchorPoint(new Point(this.pad, this.pad));

        let ratio = parseInt(ratioInput.value, 10) / 100;
        ratioDescription.innerText = ratio.toFixed(2);
        shape.setFractalProportion(ratio);

        let saturation = parseInt(saturationInput.value, 10);
        saturationDescription.innerText = saturation + '%';

        let lightness = parseInt(lightnessInput.value, 10);
        lightnessDescription.innerText = lightness + '%';

        hueRange = parseInt(hueRangeInput.value, 10);
        hueRangeDescription.innerText = hueRange + '°';

        hueOffset = parseInt(hueOffsetInput.value, 10);
        hueOffsetDescription.innerText = hueOffset + '°';

        rotation = parseInt(rotationInput.value, 10);
        rotationLabel.innerText = rotation + '°';

        shape.setRotation(rotation);
        let subShapes = shape.getProportionalSubShapes();

        this.wipe();
        if (outlineControl.checked) {
            shape.draw(this.ctx);
        }
        const iteration = ((hueRange + hueOffset) - hueOffset) / subShapes.length;
        autoOpacity = Math.max(1, Math.round(150 / subShapes.length));
        let opacity;
        if (manualRadio.checked) {
            opacity = parseInt(opacitySlider.value, 10) / Math.pow(10, opacityPrecision);
            if (opacitySlider.disabled) {
                opacitySlider.disabled = false;
            }
        } else {
            opacity = autoOpacity;
            opacitySlider.value = Math.ceil(opacity * Math.pow(10, opacityPrecision));
            if (!opacitySlider.disabled) {
                opacitySlider.disabled = true;
            }
        }
        subShapes.forEach((shape, i) => {
            let hue = sanitizeDegrees(Math.round(i * iteration) + hueOffset);
            shape.fill(this.ctx, `hsl(${hue}, ${saturation}%, ${lightness}%, ${opacity}%)`);
        });
        if (subOutlineControl.checked) {
            subShapes.forEach((shape) => {
                shape.draw(this.ctx);
            });
        }
        opacityDescription.innerText = opacity.toFixed(opacityPrecision) + '%';
    };
    const updateDrawing = noMoreThan(_updateDrawing, 100);


    controls.forEach((control) => {
        control.addEventListener('input', updateDrawing);
        control.addEventListener('change', updateDrawing);
    });

    _updateDrawing();
});


